import { LoanPaymentHeaderComponent } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodHeader/components/LoanPaymentHeaderComponent';
import { withPaymentMethodCardWrapper } from '@/components/modules/Application/components/PaymentMethod/_shared/components/PaymentMethodCard/PaymentMethodWrapper';
import { CreditLinePaymentMethod } from '@/components/modules/Application/components/PaymentMethod/CreditLine/entities/PaymentMethod/CreditLinePaymentMethod';

interface CreditLinePaymentMethodCardProps {
  paymentMethodEntity: CreditLinePaymentMethod;
}

export const CreditLinePaymentMethodCard = ({ paymentMethodEntity }: CreditLinePaymentMethodCardProps) => {
  return <LoanPaymentHeaderComponent paymentMethodEntity={paymentMethodEntity} hasLenders />;
};

export const CreditLinePaymentMethodCardWithWrapper = withPaymentMethodCardWrapper(CreditLinePaymentMethodCard);
